import {ActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ActDecorator';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';
import {StrictEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter/StrictEventEmitterWrapper';

/**
 * Extend SyncUIActDecorator if you want to block the chain of other Acts.
 * To continue chain call this.onExecuted?.() method.
 */
export abstract class SyncUIActDecorator extends ActDecorator {

    readonly emitter = new StrictEventEmitterWrapper(strictUiEmitter, this.abortSignal);
    public abstract getName(): string;

    public onExecuted?: () => void;

    public execute(): void {
    }

    public removeAllListeners(): void {
        super.removeAllListeners();
        this.emitter.offAllByOwner(this);
    }
}